import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import Button from '@mui/material/Button';
import { isMobile } from 'react-device-detect';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../redux/store';
export const ResetPasswordSuccessContents = () => {
    const navigate = useNavigate();
    const validPlayer = useAppSelector((state) => state.recoverLogin.validPlayer);
    /**
     * Only show 'Play Now' button on desktop since a mobile player may have come from a PWA mode version of the site
     * and want to avoid loading the game in the current context, which is probably a native browser.
     */
    return (_jsxs(_Fragment, { children: [_jsx("h3", { children: "Password Reset Done!" }), _jsxs("div", { children: ["You can now log in ", validPlayer ? `as ${validPlayer.name} ` : '', "with your new password!"] }), !isMobile && (_jsx("div", { css: css `
            padding-top: 30px;
          `, children: _jsx(Button, { onClick: () => {
                        navigate('/');
                    }, size: 'large', color: 'secondary', variant: 'contained', children: "Play Now!" }) }))] }));
};
